import React, { ReactNode, useEffect, useState } from 'react';
import { Box } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery/useMediaQuery';
import clsx from 'clsx';

import { AppHeader } from 'features/app/components/AppHeader';
import { AppContent } from 'features/app/components/AppContent';
import { AppSidebar } from 'features/app/components/AppSidebar';
import theme from 'styles/themes/app';

import { useStyles } from './styles';
import i18n from 'locales/i18n';
import { UploadVerification } from 'features/auth/components/UploadVerification';
import useAuth from 'features/auth/hooks/useAuth';

const SIDEBAR_BREAKPOINT = 1500;

interface AppLayoutProps {
  children: NonNullable<ReactNode>;
}

export const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const [sidebarShown, setSidebarShown] = useState(true);
  const { isUploadDocsVerificationShown, isReUploadDocs } = useAuth();
  const shouldSidebarBeShown = useMediaQuery(theme.breakpoints.up(SIDEBAR_BREAKPOINT));

  useEffect(() => {
    setSidebarShown(shouldSidebarBeShown);
  }, [setSidebarShown, shouldSidebarBeShown]);

  const direction = i18n.dir();

  const classes = useStyles({ direction });

  return (
    <Box display="flex" flexDirection="column" className={classes.root}>
      <AppSidebar show={sidebarShown} />

      <Box
        flex={1}
        display="flex"
        flexDirection="column"
        className={clsx(classes.right, { [classes.rightShift]: sidebarShown })}
      >
        <AppHeader setSidebarShown={setSidebarShown} />

        <AppContent>
          {isUploadDocsVerificationShown ? <UploadVerification isReUpload={isReUploadDocs} /> : children}
        </AppContent>
      </Box>
    </Box>
  );
};
